export const DEFAULT_ROW_NUMBER_SET = [10, 20, 30, 50, 100];
export const BIG_ROW_NUMBER_SET = [50, 100, 300, 500];
